<template>
  <div>
    <!-- 最终决策 -->
    <el-dialog title="最终决策" :close-on-click-modal="false" :visible.sync="dialogVisible" width="680px" center>
      <div class="content">
        <el-form :model="form" :rules="rules" ref="form" label-width="130px">

          <!-- 是否投诉： -->
          <el-form-item label="是否投诉：:" prop="is_complaint" v-if="form.chat_type">
            <el-radio-group v-model="form.is_complaint">
              <el-radio :label="1">非投诉</el-radio>
              <el-radio :label="2">确认投诉</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 问题分类-->
          <el-form-item label="问题分类:">
            <el-select v-model="form.problem_category" placeholder="请选择问题分类">
              <el-option v-for="(item, index) in problemCategoy" :label="item.value" :value="item.value" :key="index" />
            </el-select>
          </el-form-item>
          <!-- *确认结果 -->
          <el-form-item label="最终处理:" prop="final_solution">
            <el-input v-model="form.final_solution" placeholder="请输入确认结果" type="textarea" />
          </el-form-item>
          <!-- *问题图片： -->
          <el-form-item label="处理截图:">
            <div class="image">
              <div v-for="(item, index) in form.final_images" :key="index" class="image-item">
                <img :src="item" class="avatar" />
                <i class="el-icon-error" @click="removeImage(index)"></i>
              </div>
              <el-upload class="avatar-uploader" action="/api/upload" :show-file-list="false" list-type="picture-card"
                :before-upload="beforeAvatarUpload" :http-request="httpup" multiple>
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
          <!-- *不良数： -->
          <el-form-item label="售后单号:">
            <el-input v-model="after_sale_sn_list" placeholder="请输入售后单号" />
          </el-form-item>
          <!-- *不良金额（元）： -->
          <el-form-item label="赔款单号:">
            <el-input v-model="reparation_sn_list" placeholder="赔款单号" />
          </el-form-item>

          <el-form-item>
            <p style="color:red;">多个单号的情况下以空格进行分隔，数据保存后系统会以空格进行识别</p>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
export default {

  props: {
    problemCategoy: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: {
        client_id: '',
        problem_images: [],
        final_solution: '',
        problem_category: '',
        after_sale_sn: '',
        reparation_sn: '',
      },
      after_sale_sn_list: '',
      reparation_sn_list: '',
      rules: {
        client_id: [{ required: true, message: '请输入客户ID', trigger: 'blur' }],
        final_images: [{ required: true, message: '请上传问题图片', trigger: 'blur' }],
        final_solution: [{ required: true, message: '请输入售后问题说明', trigger: 'blur' }],
        problem_category: [{ required: true, message: '请选择问题分类', trigger: 'blur' }],
        product_id: [{ required: true, message: '请输入配送单', trigger: 'blur' }],
        order_id: [{ required: true, message: '请输入订单', trigger: 'blur' }],
        problem_num: [{ required: true, message: '请输入不良数', trigger: 'blur' }],
        problem_amount: [{ required: true, message: '请输入不良金额（元）', trigger: 'blur' }],
        is_problem: [{ required: true, message: '请选择是否问题', trigger: 'blur' }],
        is_complaint: [{ required: true, message: '请选择是否投诉', trigger: 'blur' }],
      },
      dialogVisible: false,

      radio: 1,
      chat_type: '',
    };
  },
  created() {

  },
  methods: {

    // 保存
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {

          if (this.after_sale_sn_list) {
            this.form.after_sale_sn = this.after_sale_sn_list.split(' ')
          }
          if (this.reparation_sn_list) {
            this.form.reparation_sn = this.reparation_sn_list.split(' ')
          }

          this.$api.siteConfiguration.aftersaleIssueFinalHandle(this.form).then(res => {
            this.$message.success(res.msg);
            this.$parent.aftersaleIssueList();
            this.$parent.aftersaleIssueStatusStatistics();
            this.dialogVisible = false;
          })
        } else {
          this.$message.error('请填写完整信息');
        }
      })
    },
    // 删除沟通截图
    removeImage(index) {
      this.form.final_images.splice(index, 1);
    },
    // 上传沟通截图前
    beforeAvatarUpload(file) {
      if (this.form.final_images.length >= 6) {
        this.$message.error('最多上传6 张业务处理截图!');
        return false;
      }
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isSVG = file.type === 'image/svg+xml';
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error('上传业务处理截图只能是 JPG/PNG/SVG 格式!');
      }
      return isJPG || isPNG || isSVG;
    },
    // 上传沟通截图
    // 图片上传事件
    async httpup(file) {
      let data = await this.createClient(file)
      this.form.final_images.push(data.data)
    },

  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;

    .input {
      width: 300px;
      margin-right: 20px;
    }
  }

  .image {
    display: flex;
    flex-wrap: wrap;

    .image-item {
      position: relative;
      margin-bottom: 10px;
      margin-right: 10px;

      .el-icon-error {
        position: absolute;
        top: -5px;
        right: -5px;
        font-size: 20px;
        color: #ff4949;
        cursor: pointer;
      }
    }

    .avatar {
      width: 80px;
      height: 80px;
      border-radius: 4px;

    }
  }

  .avatar-uploader {
    height: 80px;
    width: 80px;
  }

  /deep/.el-upload--picture-card {
    width: 80px;
    height: 80px;
    line-height: 80px;
  }

  /deep/.el-textarea__inner {
    height: 100px;
  }

  .list {
    margin-top: 10px;

    p {
      line-height: 30px;
    }
  }

  .el-icon-question {
    font-size: 20px;
    color: #B4272D;
    margin-left: 20px;
    cursor: pointer;
  }
}
</style>